<template>
  <div class="signin-container">
        <div class="signin-container__left">
            <img src="../../assets/img/certilogo.png" class="logo-image"  >
            <div class="signin-container__left-bg" :class="[bgStyleNumber, leftBgClass]">
                <carousel :autoplay="false" :wrap-around="false" :items-to-show="1" @slide-start="slideStartFunction">
                    <slide :key="1">
                        <img style="width: 363px;" :src="loginImageSrc"  >
                    </slide>
                </carousel>
            </div>
        </div>
        <div class="signin-container__right" style="padding-bottom: 20px;">
            <img src="../../assets/img/certilogo.png" class="mobile-logo-image no-mobile"  >
            <div class="signin-container__right-bg" :class="bgStyleNumber" style="margin-bottom: auto;">
                <div class="signin-container-wrap">
                    <div class="signin-area">
                        <div class="logo-wrap">
                            <img src="../../assets/img/login/icon-manufacturer.webp" />
                        </div>
                        <div class="title-wrap">
                            <h4>
                                登录
                            </h4>
                        </div>
                        <div class="input-wrap">
                            <p class="input-title">
                                账号
                            </p>
                            <a-input
                                v-model:value="email"
                                placeholder="账号"
                                @keyup.enter="signIn"
                                @input="handleIdValue"
                                >
                                <template #prefix>
                                    <i class="fa-regular fa-user" />
                                </template>
                            </a-input>
                        </div>
                        <div class="input-wrap">
                            <p class="input-title">
                                密码
                            </p>
                            <a-input-password
                                placeholder="密码"
                                id="password"
                                v-model:value="password"
                                @keyup.enter="signIn"
                            >
                                <template #prefix>
                                    <i class="fa-regular fa-key" />
                                </template>
                            </a-input-password>
                        </div>
                        <a-button @click="signIn" type="primary">
                            登录
                        </a-button>
                    </div>
                </div>
            </div>
        </div>
    <!-- <div class="footer-wrap">
      <span>{{ $t('signin_certilife_text') }}</span>
      <span>ㆍ</span>
      <a :href="privacyPolicyUrl" target="_blank">{{ $t('signin_pp') }}</a>
      <span>ㆍ</span>
      <a :href="termsOfUseUrl" target="_blank">{{ $t('signin_tos') }}</a>
    </div> -->
  </div>
</template>
<script setup>
import {reactive} from "vue";
import {useForm} from "ant-design-vue/es/form";

    const modelRef = reactive({
        name: '',
        region: undefined,
    });
    const rulesRef = reactive({
    name: [
        {
        required: true,
        message: 'Please input Activity name',
        },
        {
        min: 3,
        max: 5,
        message: 'Length should be 3 to 5',
        trigger: 'blur',
        },
    ]
    });
    const {resetFields, validate, validateInfos} = useForm(modelRef, rulesRef);
</script>
<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import CustomButton from '../components/CustomButton.vue';
import {jwtDecoder, logging, oneBtnDialog, oneBtnHtmlDialog, twoBtnDialog} from '../../utils/utils';
import {Constants} from '../../utils/constants';
import {localStorageEnums} from "@/enums/localStorage.enums";
import { bridges } from '@/utils/bridges';
import { signInMixin } from '@/mixins/signInMixin';
// @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-TENANT-REGISTRY-001 — hostname 기반 brand 분기 통합
//   기존: hostname.includes('dentalmax') inline 분기 + 자산 직접 import 분산 (Signin.vue 152/159)
//   현재: tenantRegistry 단일 진입점, resolveTenant() 한 번 호출로 모든 brand 자산 해석
//   향후 신규 고객사 = src/config/tenantRegistry.js 1 항목 등록 (SOLID OCP 준수)
import { resolveTenant } from '@/config/tenantRegistry';

const body = document.getElementsByTagName('body')[0];

export default {
    name: 'ChinaDentiumSignin',
    mixins: [signInMixin],
    components: {
        CustomButton,
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    data() {
        return {
            email: '',
            password: '',
            showPassword: false,
            privacyPolicyUrl: Constants.policiesUrl.privacyPolicyUrl,
            termsOfUseUrl: Constants.policiesUrl.termsOfUseUrl,
            bgStyleNumber: 'bg-1',
            // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-TENANT-REGISTRY-001 — hostname 1회 resolve 후 data 캐싱
            //   computed 매 호출마다 hostname 조회 불필요. data로 마운트 시점 1회 해석 + 이후 재사용.
            tenant: resolveTenant(typeof window !== 'undefined' ? window.location.hostname : ''),
        };
    },
    created() {
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDEBAR-CONSOLID-001 — UI toggle commit 제거 (isCustomPage 단일 조건으로 통합)
        body.classList.remove('bg-white-100');
        console.log('Referrer:', document.referrer);
    },
    mounted() {

    },
    beforeUnmount() {
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-SIDEBAR-CONSOLID-001 — UI toggle commit 제거 (isCustomPage 단일 조건으로 통합)
        body.classList.add('bg-white-100');
    },
    computed: {
        isPasswordEmpty() {
            return this.password === '';
        },
        isEmailEmpty() {
            return this.email === '';
        },
        // @MX:NOTE: [AUTO] SPEC-CHINA-ADMIN-TENANT-REGISTRY-001 — tenant 캐싱된 자산 직접 반환 (Strategy 패턴)
        //   기존: hostname inline 분기 + dentalmaxLoginImage/dentiumLoginImage import 분산
        //   현재: tenant.loginImage / tenant.leftBgClass 직접 반환 (alias computed로 template 호환성 보존)
        loginImageSrc() {
            return this.tenant.loginImage;
        },
        leftBgClass() {
            return this.tenant.leftBgClass;
        },
    },
    methods: {


        //MARK: webToApp_TEST
        /*
        data = { key0: 'valueString0', key1: 12345, key2: false }
        */
        async requestWebToApp_TEST() {
            console.log('Signin.vue requestWebToApp_TEST')

            const requestWebToAppValue = { key0: 'valueStringFromWeb0', key1: 1234567890, key2: true }

            window.requestWebToApp_TEST(requestWebToAppValue)
        },


        handleIdValue() {
            this.email = this.email.replace(/\s+/g, '');
        },
        slideStartFunction(data) {
            this.bgStyleNumber = `bg-${data.slidingToIndex+1}`
        },
        async findPwd(event) {
            // event.preventDefault();
            await oneBtnDialog(this.$t('signin_dentium_pwcheck_title'), this.$t('signin_dentium_pwcheck_content'), false);
            const findPwdTag = this.$refs.findPwd
            if (findPwdTag) {
                window.open('https://certi.life/#contact');
            }
        },
        async validateData() {
            let result = true;
            if (!this.email) {
                result = false;
                await oneBtnDialog(this.$t('signin_id_empty_err_title'), this.$t('signin_id_empty_err_content'), false);
            } else if (!this.password) {
                result = false;
                await oneBtnDialog(this.$t('signin_pw_empty_err_title'), this.$t('signin_pw_empty_err_content'), false);
            }
            return result;
        },

        /**
         * 로그인 처리
         * - signInMixin (admin-manufacturer 신버전 패턴) 위임
         * - roles 배열로 MANUFACTURER → DENTAL_LABORATORY 순차 시도
         *   (백엔드 RoleHierarchyService.canLoginAs() 통과 보장)
         * - 후속 처리(getUserInfo) throw가 "로그인 실패" dialog로 오인되지 않도록 mixin이 격리
         */
        async signIn() {
            if (!await this.validateData()) return;
            const email = this.email.trim();
            // [2026-08-03] 도메인이 곧 대상이다 — 시도할 role 은 tenantRegistry 가 정한다.
            // manufacturer.* → [MANUFACTURER, DENTAL_LABORATORY] / hospital.* → [HOSPITAL]
            const roles = this.tenant.loginRoles;

            const { response, lastError } = await this.performLogin(email, this.password, roles);

            if (response) {
                await this.handleLoginSuccess(response, email);
            } else {
                await this.handleLoginError(lastError);
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/signin';

a.forwardLink:hover {
  color: #278AEC
}
</style>
